﻿import Spinner = require("spin.js");

export interface IMediumSpinnerScope extends ng.IScope {
    idiMediumSpinner: '=';
}

export class idiMediumSpinner implements ng.IDirective {
    public template: string = '<div class=mediumspinner  id=mediumspinner></div>';
    public replace: boolean = true;
    public target: HTMLElement;
    public scope = { idiMediumSpinner: '=' };
    private spinner: Spinner = null;

    public link = (scope: IMediumSpinnerScope) => {

        scope.$watch('idiMediumSpinner', (value: boolean) => {

            if (value === false) {
                if (this.spinner !== null) {
                    this.spinner.stop();
                    this.spinner = null;
                };
            }

            if (value) {
                var opts = {
                    lines: 13,
                    length: 6,
                    width: 5,
                    radius: 14,
                    scale: 1,
                    corners: 1,
                    color: '#006196',
                    opacity: 0.25,
                    rotate: 0,
                    direction: 1,
                    speed: 1,
                    trail: 60,
                    fps: 20,
                    className: 'spinner',
                    shadow: false,
                    hwaccel: false,
                    position: 'absolute'
                }
                this.target = document.getElementById('mediumspinner');
                this.spinner = new Spinner(opts).spin(this.target);
            }
        });
    }

    static factory(): ng.IDirectiveFactory {
        return () => new idiMediumSpinner();
    }
}
